import { render, staticRenderFns } from "./TranProgramActivityReminderList.vue?vue&type=template&id=4dbd9c2f&scoped=true"
import script from "./TranProgramActivityReminderList.vue?vue&type=script&lang=js"
export * from "./TranProgramActivityReminderList.vue?vue&type=script&lang=js"
import style0 from "./TranProgramActivityReminderList.vue?vue&type=style&index=0&id=4dbd9c2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbd9c2f",
  null
  
)

export default component.exports